import { useTranslation } from "../../core/translation.core";
import { OrderList } from "../../types/order";
import { ORDER_REQUIRED_COLUMNS, OrderCheckedItemsState, OrderListColumnKey } from "../../pages/orders";
import NoRecordDisplay from "../common/noRecord.comp";
import { ListSection } from "../reuseables/list.comp";
import OrderRow from "./orderRow.comp";

export default function OrderListComp({ orders, checkedItems }: { orders?: OrderList; checkedItems: OrderCheckedItemsState }) {
  const { t, msg } = useTranslation();
  const columns: { key: OrderListColumnKey; size: string; title: string; className?: string }[] = [
    { key: "orderNumber", size: "100px", title: "#" },
    { key: "date", size: "200px", title: t(msg.order.date) },
    { key: "orderStatus", size: "120px", title: t(msg.order.orderStatus) },
    { key: "paymentStatus", size: "120px", title: t(msg.order.paymentStatus) },
    { key: "deliveryStatus", size: "120px", title: t(msg.delivery.deliveryStatus) },
    { key: "stockHoldStatus", size: "100px", title: t(msg.order.stockHoldStatus) },
    { key: "customer", size: "300px", title: t(msg.order.customer) },
    { key: "products", size: "minmax(300px,1fr)", title: t(msg.product.products) },
    { key: "amount", size: "100px", title: t(msg.order.amount), className: "text-right" },
    { key: "paymentType", size: "100px", title: t(msg.order.paymentType) },
    { key: "posSystem", size: "80px", title: t(msg.pos.posSytem) },
  ];
  const activeColumns = columns.filter((col) => ORDER_REQUIRED_COLUMNS.includes(col.key) || checkedItems[col.key]);
  const gridTemplateColumns = activeColumns.map((col) => col.size).join(" ");

  return (
    <ListSection>
      <div id="order-section" data-count={orders ? orders.size : 0} className="overflow-x-auto">
        <div className="hidden lg:grid gap-x-6 border-b pb-4 px-6 py-3" style={{ gridTemplateColumns }}>
          {activeColumns.map((col) => (
            <div key={col.key} className={col.className}>
              {col.title}
            </div>
          ))}
        </div>
        {orders && orders.list.length > 0 ? (
          orders?.list.map((order) => <OrderRow order={order} checkedItems={checkedItems} key={order.id} />)
        ) : (
          <NoRecordDisplay />
        )}
      </div>
    </ListSection>
  );
}
